import { render, staticRenderFns } from "./scoreranking.vue?vue&type=template&id=6e5ac05d&"
import script from "./scoreranking.vue?vue&type=script&lang=js&"
export * from "./scoreranking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports